const StoreInboxReducers = (state = {}, action) => {
  switch (action.type) {
    case "storeInboxDetail":
      return action.payload;
    default:
      return state;
  }
};
export default StoreInboxReducers;
